var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeyboardLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "brightness-keyboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 16.723c0.69 0 1.25-0.56 1.25-1.25v0-6.473c0-0.69-0.56-1.25-1.25-1.25s-1.25 0.56-1.25 1.25v0 6.473c0 0.69 0.56 1.25 1.25 1.25v0zM7 21.75h-5c-0.69 0-1.25 0.56-1.25 1.25s0.56 1.25 1.25 1.25v0h5c0.69 0 1.25-0.56 1.25-1.25s-0.56-1.25-1.25-1.25v0zM30 21.75h-5c-0.69 0-1.25 0.56-1.25 1.25s0.56 1.25 1.25 1.25v0h5c0.69 0 1.25-0.56 1.25-1.25s-0.56-1.25-1.25-1.25v0zM10.781 18.885c0.226-0.226 0.366-0.539 0.366-0.884s-0.14-0.658-0.366-0.884l-4.576-4.577c-0.226-0.226-0.539-0.366-0.884-0.366-0.69 0-1.25 0.56-1.25 1.25 0 0.345 0.14 0.658 0.366 0.884l4.576 4.578c0.226 0.226 0.539 0.365 0.884 0.365s0.657-0.14 0.884-0.365l-0 0zM27.564 12.539c-0.226-0.226-0.539-0.366-0.884-0.366s-0.658 0.14-0.884 0.366v0l-4.58 4.577c-0.227 0.226-0.367 0.539-0.367 0.884 0 0.69 0.559 1.25 1.25 1.25 0.001 0 0.001 0 0.002 0h-0c0.001 0 0.003 0 0.005 0 0.343 0 0.654-0.14 0.878-0.365l4.58-4.578c0.226-0.226 0.366-0.539 0.366-0.884s-0.14-0.657-0.365-0.884l0 0zM21 21.75h-10c-0.69 0-1.25 0.56-1.25 1.25s0.56 1.25 1.25 1.25v0h10c0.69 0 1.25-0.56 1.25-1.25s-0.56-1.25-1.25-1.25v0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardLight);
export default __webpack_public_path__ + "static/media/keyboard_light.43fb627d0d615035c8529764f400a7b8.svg";
export { ForwardRef as ReactComponent };